import * as React from 'react'

import { Box, CheckBox, Text } from '@factorialco/deprecated-design-system'
import { difference } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

interface Props {
  disabled: boolean
  onSelectMultiple?: ((selectedIds: number[]) => void) | null
  selectedIds: number[]
  timeoffPolicies: TimeoffPolicy[]
}

export default function Controls({
  onSelectMultiple,
  timeoffPolicies,
  selectedIds,
  disabled,
}: Props) {
  if (!onSelectMultiple) return null

  const timeoffPoliciesIds = timeoffPolicies.map((policy) => policy.attributes.id)

  const onSelectAll = () => {
    if (disabled) return

    if (!timeoffPoliciesIds.length) return onSelectMultiple(timeoffPoliciesIds)

    const selection = [...new Set([...selectedIds, ...timeoffPoliciesIds])]
    onSelectMultiple(selection)
  }

  const onSelectNone = () => {
    if (disabled) return

    onSelectMultiple(difference(selectedIds, timeoffPoliciesIds))
  }

  const selected = !difference(timeoffPoliciesIds, selectedIds).length
  const toggle = () => (selected ? onSelectNone() : onSelectAll())

  return (
    <Box
      alignItems="center"
      background="grey200"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <CheckBox checked={selected} onClick={toggle} />
      <Text.Normal size="200" weight="medium">
        {i18n.t('time_tracking.settings.overtime.compensation.timeoff.modal.form_title')}
      </Text.Normal>
    </Box>
  )
}
